import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=724c9c46&scoped=true&"
import script from "./Lessons.vue?vue&type=script&lang=js&"
export * from "./Lessons.vue?vue&type=script&lang=js&"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=724c9c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c9c46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
